import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Home from "@/pages/Home";
import About from "@/pages/About";
import SecuritySystems from "@/pages/SecuritySystems";
import ElvSystems from "@/pages/ElvSystems";
import PaAvSystems from "@/pages/PaAvSystems";
import WhyChooseUs from "@/pages/WhyChooseUs";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#0A0F1D] min-h-screen text-slate-300">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/security-systems" element={<SecuritySystems />} />
          <Route path="/elv-systems" element={<ElvSystems />} />
          <Route path="/pa-av-systems" element={<PaAvSystems />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
        <Toaster theme="dark" position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
